<template>
    <div class="problem">
        <!-- <p class="title">常见问题</p> -->
        <el-row type="flex" class="row-bg main" justify="center">
            <el-col :span="20">
                <div class="content">
                    <!-- <p>1、我想加盟壹米滴答，需要满足哪些条件？</p>
                    <p>答：您只需要满足以下条件即可加入我们：</p>
                    <p>① 认同壹米滴答发展的理念，有相同的发展愿景；</p>
                    <p>② 具备揽货能力及基本配送能力；</p>
                    <p>③ 统一使用信息系统、资金账户、统一网点经营、统一品牌形象；</p>
                    <p>④ 接受壹米滴答业务量考核，严格执行运营标准，并接受管控考核；</p>
                    <p>⑤ 缴纳一定的押金、系统使用费等费用。</p>
                    <p>2、我有多年物流网点经营管理经验，想加盟一个好的平台，壹米滴答的产品具有竞争力吗？</p>
                    <p>答：壹米滴答的成员企业均为各区域领先物流，我们打造的“县镇通”主营产品，以末端无盲点的派送优势加以省内中转无缝对接支撑，无论是在网络覆盖，还是价格、时效方面均能提供保障。</p>
                    <p>3、我没有货运行业经验，请问是否可以加盟？</p>
                    <p>答：壹米滴答具有非常成熟的运营和经营平台，同时我们会提供统一的培训、系统、金融等资源支持，你只需要按照总部指导方案经营即可。</p> -->
                    <div
                        class="content"
                        v-html="articleContent.osArticleContent.content"
                    ></div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { queryarticlebyid } from "@/api/apiall";
export default {
    data() {
        return {
            category: "",
            articleContent: {}
        };
    },
    created() {
        this.category = this.$route.query.id;
        this.aueryfindbytype();
    },
    methods: {
        aueryfindbytype() {
            queryarticlebyid({ categoryId: this.category, platform: "1" }).then(
                res => {
                    if (res.status == 2000) {
                        this.articleContent = res.data;
                    }
                }
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.problem {
    padding-bottom: 59px;
    padding-top: 30px;
    background-color: #fff;
    .main {
        .el-col {
            // border: 1px solid #ccc;
            .content {
                white-space: pre-line;
                word-wrap: break-word;
                word-break: break-all;
                // margin-left: 60px;
                p {
                    font-size: 14px;
                    color: #666;
                    margin-top: 20px;
                }
                p:nth-child(1),
                p:nth-child(8),
                p:nth-child(10) {
                    font-size: 16px;
                    margin-top: 30px;
                    font-weight: 500;
                    color: #000;
                }
            }
        }
    }
}
</style>
